import { render, staticRenderFns } from "./crm-shipments.vue?vue&type=template&id=04cbc689&scoped=true&"
import script from "./crm-shipments.vue?vue&type=script&lang=js&"
export * from "./crm-shipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cbc689",
  null
  
)

export default component.exports